export enum EThingQdosStatusNum {
  pending = 0,
  saved = 1,
  done = 2,
}

export interface IThingQdosState {
  all: IThingQdos[] | [];
  pages: number | undefined;
  posts: TPosts;
}

type Owner = {
  _id: string;
  name: string;
};
type Creator = {
  _id: string;
  name: string;
};

export interface IThingQdos {
  _id: string;
  alternativeId: string;
  ownerId: string;
  creatorId: string;
  eventId: string;
  status: number;
  createdAt: string;
  updatedAt: string;
  eventName?: string; 
  owner: Owner;
  creator: Creator;
}

export type TPost = {
  post: {
    _id: string;
    imageId: string;
    itemIds: string[];
    eventId: string;
    alternativeId: string;
    ownerTwitterIds: string[];
    eventLinks: string[];
    ownerCurrentFundMeLink: string[];
    description: string;
    eventTitle: string;
    created_At: string;
    cropped: boolean;
    mediaType?: string;
    videoUrl?: string;
  };
};

export type TPosts = Array<{ _id: string } & TPost>;

export type TThingQdosGetAllPayload = number | undefined;
export type TThingQdosGetAllPostsByItemIdPayload = string;

export interface IThingQdosGetAllResponseOk {
  data: IThingQdos[];
  pages: number;
}

export type TThingQdosGetAllPostsByItemIdResponseOk = TPosts;
